module.exports = __webpack_public_path__ + "static/pwr4logo-8f5dfa5d9d34e77567420e1aeedbbbe9.png";